import { Card } from "../../../components/card/card.jsx";
import { DataTable } from "../../../components/table/table.tsx";
import { useEffect, useState } from "react";
import { apiUrl } from "../../../config/config.js";
import Swal from "sweetalert2";
import ParticipantDetailModal from "./participantDetail.js";
import { Form } from "react-bootstrap";

const Toast = Swal.mixin({
	toast: true,
	position: "top-end",
	showConfirmButton: false,
	timer: 3000,
	timerProgressBar: true,
	didOpen: (toast) => {
		toast.onmouseenter = Swal.stopTimer;
		toast.onmouseleave = Swal.resumeTimer;
	},
});



function Participants() {
	const [participants, setParticipants] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	//Para ver el detalle de un participante
	const [participant, setParticipant] = useState(null);
	const [showModal, setShowModal] = useState(false);

	//Para filtrar por torneo
	const [tournaments, setTournaments] = useState([]);
	const [selectedTournament, setSelectedTournament] = useState('');

	useEffect(() => {
		const loadTournaments = async () => {
			try {
				const response = await fetch(`${apiUrl}/tournaments-all?menu=true`, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
					}
				});
				const data = await response.json();
				setTournaments(data.data || []);
			} catch (err) {
				console.error('Error cargando torneos', err);
			}
		};
		loadTournaments();
		fetchParticipants();
	}, []);

	const fetchParticipants = async () => {
		setIsLoading(true);
		try {
			const response = await fetch(`${apiUrl}/participants`, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
				}
			});
			if (response.ok) {
				const { data } = await response.json();
				console.log(data);
				setParticipants(data || []);
			} else {
				Toast.fire({
					icon: "error",
					title: "Error al cargar los participantes",
					background: "#1e2836",
				});
			}
		} catch (error) {
			console.error("Error fetching participantss:", error);
			Toast.fire({
				icon: "error",
				title: "Error al cargar los participantes",
				background: "#1e2836",
			});
		}
		setIsLoading(false);
	}

	useEffect(() => {
		const loadParticipantsByTournament = async () => {
			if (!selectedTournament) {
				fetchParticipants()
				return;
			};
			try {
				const response = await fetch(`${apiUrl}/participants?tournament=${selectedTournament}`, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
					}
				});
				const { data } = await response.json();
				setParticipants(data || []);
			} catch (err) {
				console.error('Error cargando participantes por torneo', err);
			}
		};

		loadParticipantsByTournament();
	}, [selectedTournament]);

	if (isLoading) {
		return (
			<div className="text-center">
				<div className="spinner-border text-primary" role="status">
					<span className="visually-hidden">Cargando...</span>
				</div>
			</div>
		);
	}

	const openModal = async (participant) => {
		console.log("Opening modal for participant ID:", participant);
		try {
			const response = await fetch(`${apiUrl}/participants/${participant}`, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
				}
			});
			if (response.ok) {
				const { data } = await response.json();
				console.log("Participant data:", data, apiUrl);
				setParticipant(data || null);
				setShowModal(true);
			} else {
				Toast.fire({
					icon: "error",
					title: "Error al cargar el participante",
					background: "#1e2836",
				});
			}
		} catch (error) {
			console.error("Error fetching participant by id:", error);
			Toast.fire({
				icon: "error",
				title: "Error al cargar el participante",
				background: "#1e2836",
			});
		}
	}

	return (
		<div>
			<div className="d-flex align-items-center mb-3">
				<div>
					<h1 className="page-header mb-0">Participantes</h1>
					<Form.Select
						value={selectedTournament}
						onChange={(e) => setSelectedTournament(e.target.value)}
					>
						<option value="">-- Selecciona un torneo --</option>
						{tournaments.map((t) => (
							<option key={t.id} value={t.id}>
								🏆 {t.nameTournament} — {t.participants} participantes
							</option>
						))}
					</Form.Select>
				</div>
			</div>
			<Card>
				<div className="tab-content p-4">
					<div className="tab-pane fade show active" id="allTab">
						<DataTable data={participants}
							hiddenFields={['idParticipant']}
							columns={[
								{ key: 'nameParticipant', label: 'Nombre' },
								{ key: 'emailParticipant', label: 'Correo electrónico' },
								{ key: 'community', label: 'Comunidad' },
								{ key: 'idMT5', label: 'Cuenta MT5' },
								{ key: 'phone', label: 'Teléfono' },
								{ key: 'country', label: 'País' },
								{ key: 'tournament', label: 'participante' },
							]}
							onRowClick={async (row) => await openModal(row.idParticipant)} />
					</div>
				</div>
			</Card>
			{showModal && participant && (
				<ParticipantDetailModal
					show={showModal}
					participant={participant}
					onClose={() => {
						setParticipant(null);
						setShowModal(false);
					}}
				/>
			)}
		</div>
	);
}

export default Participants;
